import Service1 from'./Images/service-1.png';
import Service2 from './Images/service-2.png';
import Service3 from './Images/service-3.png';
import Service4 from './Images/service-4.png';
import Service5 from './Images/service-5.png';
import Service6 from './Images/service-6.png';

export const Services=[
    {
    title:"Business Strategy",
    desc:"Smart, tailored strategies to guide your business toward long-term success.",
    icon:Service1
    },
     {
    title:"Financial Consulting",
    desc:"Clear financial insights to improve profitability and performance.",
    icon:Service2
    },
     {
    title:"Marketing & Branding",
    desc:"Creative solutions to boost your brand visibility and customer reach.",
    icon:Service3
    },
     {
    title:"Process Optimization",
    desc:"Streamlined processes that enhance efficiency and reduce costs.",
    icon:Service4
    },
     {
    title:"Digital Solutions",
    desc:"Modern digital tools and systems that elevate your business operations.",
    icon:Service5
    },
     {
    title:"HR & Talent",
    desc:"Strong people-focused strategies to build and develop high-performing teams.",
    icon:Service6
    }
]